module.exports = __webpack_public_path__ + "static/media/stethoscope.d0211ebc.svg";